export const FULL_PERMISSIONS = {
  merchants: 'write',
  vouchers: 'write',
  menu_items: 'write',
  user_mgmt: 'write',
  reports: 'write',
  settings: 'write',
} as const;

export const DEFAULT_ADMIN_PERMISSIONS = {
  merchants: 'write',
  vouchers: 'write',
  menu_items: 'write',
  user_mgmt: 'read',
  reports: 'read',
  settings: 'none',
} as const;

export const DEFAULT_SUPPORT_PERMISSIONS = {
  merchants: 'read',
  vouchers: 'read',
  menu_items: 'read',
  user_mgmt: 'none',
  reports: 'read',
  settings: 'none',
} as const;

export type PermissionLevel = 'none' | 'read' | 'write';
export type PermissionsMap = Record<string, PermissionLevel>;
